import React from "react";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  SubTitle,
  ThirdTitle,
} from "../ContentsStyles";

const CG_9 = () => {
  return (
    <>
      <Parah>
        We work to ensure Talents Explore does not enable activities that
        violate laws or regulations. We prohibit the trade, sale, promotion, and
        use of certain regulated goods, as well as the promotion or facilitation
        of criminal activities, including human exploitation. Content may be
        removed if it relates to activities or goods that are regulated or
        illegal in the majority of the region or world.
      </Parah>
      <SubTitle>Criminal Activities</SubTitle>
      <Parah>
        Criminal activities cover a wide spectrum of acts punishable by law,
        including theft, assault, human exploitation, counterfeiting, and other
        harmful behavior. To prevent such behavior from being normalized,
        imitated, or facilitated, we remove content that promotes or enables
        criminal activities.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that promotes acts of physical harm, such as assault or
        kidnapping.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that risks the safety of others, including swatting.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that promotes human exploitation, including human smuggling,
        bonded labour, domestic servitude, sex trafficking, or prostitution.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that promotes vandalism or damage to property.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that promotes the poaching or illegal trade of wildlife.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that offers the purchase, sale, trade, or solicitation of
        unlawfully acquired or counterfeit goods.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that provides instructions on how to conduct criminal activities
        that result in harm to people, animals, or property.
      </PointsWrapper>
      <SubTitle>Weapons</SubTitle>
      <Parah>
        We do not allow the depiction, promotion, or trade of firearms,
        ammunition, firearm accessories, or explosive weapons. We also prohibit
        instructions on how to manufacture those weapons. We may allow depiction
        when appearing in educational contexts (e.g., as part of a museum's
        collection), involving authorized government personnel (e.g., a police
        officer) or used in a safe and controlled environment (e.g., shooting
        range, recreational hunting).
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that displays firearms, firearm accessories, ammunition, or
        explosive weapons.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that offers the purchase, sale, trade, or solicitation of
        firearms, accessories, ammunition, explosive weapons, or instructions on
        how to manufacture them.
      </PointsWrapper>
      <SubTitle>Drugs, Controlled Substances, Alcohol, and Tobacco</SubTitle>
      <Parah>
        We do not allow the depiction, promotion, or trade of drugs or other
        controlled substances. The trade of tobacco and alcohol products is also
        prohibited on the platform.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts or promotes drugs, drug consumption, or encourages
        others to make, use, or trade drugs or other controlled substances.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that offers the purchase, sale, trade, or solicitation of drugs
        or other controlled substances, alcohol or tobacco products (including
        vaping products, smokeless or combustible tobacco products, synthetic
        nicotine products, E-cigarettes, and other ENDS [Electronic Nicotine
        Delivery Systems]).
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that provides information on how to buy illegal or controlled
        substances.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts or promotes the misuse of legal substances, or
        instruction on how to make homemade substances, in an effort to become
        intoxicated.
      </PointsWrapper>
      <SubTitle>Frauds and Scams</SubTitle>
      <Parah>
        We do not permit anyone to exploit our platform to take advantage of the
        trust of users and bring about financial or personal harm. We remove
        content that deceives people in order to gain an unlawful financial or
        personal advantage, including schemes to defraud individuals or steal
        assets.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that promotes phishing.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that promotes Ponzi, multi-level marketing, or pyramid schemes.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that promotes investment schemes with promise of high returns,
        fixed betting, or any other types of scams.
      </PointsWrapper>
      <SubTitle>Gambling</SubTitle>
      <Parah>
        We do not allow content promoting gambling services, or that could be
        perceived as advertising for casinos, sports betting, or any other
        commercial gambling activity.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that promotes casinos, sports betting, poker, lotteries,
        gambling-related software and apps, or other gambling services.
      </PointsWrapper>
      <SubTitle>
        Privacy, Personal Data, and Personally Identifiable Information (PII)
      </SubTitle>
      <Parah>
        We do not allow content that violates the confidentiality of personal
        data or personally identifiable information (e.g., social security
        information, phone numbers, physical addresses). We remove content that
        depicts personal data or personally identifiable information (PII) from
        the platform.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that contains personal data or personally identifiable
        information (PII).
      </PointsWrapper>
    </>
  );
};

export default CG_9;
